<template>
  <div>
     <div class="fixed-top-bar d-flex align-center">
      <v-row>
        <!-- <v-col cols="1">
          <v-btn icon dark disabled="">
            <v-icon size="36px"> mdi-arrow-left-bold-box-outline </v-icon>
          </v-btn>
        </v-col> -->
        <v-col cols="3">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                @click="dialog = true"
                disabled
                class="ml-7"
              >
                <v-icon size="36px"> mdi-file-plus-outline </v-icon>
                 <span class="lable_class">Add</span>
              </v-btn>
            </template>
            <span>Add</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                disabled
                class="ml-5"
              >
                <v-icon size="36px"> mdi-clipboard-edit-outline </v-icon>
                 <span class="lable_class">Add</span>
              </v-btn>
            </template>
            <span>Edit</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon dark v-bind="attrs" v-on="on" disabled
              class="ml-5">
                <v-icon size="36px"> mdi-eye-outline </v-icon>
                 <span class="lable_class">View</span>
              </v-btn>
            </template>
            <span>View</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                disabled
                class="ml-5"
              >
                <v-icon size="36px"> mdi-delete-outline </v-icon>
                 <span class="lable_class">Delete</span>
              </v-btn>
            </template>
            <span>Delete</span>
          </v-tooltip>
        </v-col>
        <v-col cols="3">
            <v-btn icon small dark class="ml-1" disabled="">
                <v-icon size="36px">mdi-magnify</v-icon>
                <span class="lable_class">Search</span>
            </v-btn>
            <v-menu bottom :close-on-content-click="false" content-class="elevation-0" v-model="filter_menu">
                <template v-slot:activator="{ on, attrs }">
                  <span class="lable_class">Filter</span>
                  <v-btn dark icon v-bind="attrs" v-on="on" class="ml-1">
                    <v-icon size="22px">mdi-filter-menu-outline</v-icon>
                  </v-btn>
                </template>
                <v-card tile max-width="310" class="mb-5 mr-5">
                  <v-list class="filter-section-border">
                    <v-list-item class="mt-0">
                      <v-autocomplete
                        dense
                        flat
                        :items="view_by"
                        outlined
                        label="View By"
                        hide-details
                        class="body-2"
                        placeholder=" "
                        v-model="filter_view_by"
                        @change="changeFilter()"
                      ></v-autocomplete>
                    </v-list-item>
                  </v-list>
                  <v-card-title class="pa-0">
                  <v-btn
                    fab
                    color="error"
                    x-small
                    absolute
                    @click="filter_menu = false"
                    class="custom-close-btn"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-card-title>

                </v-card>
              </v-menu>
        </v-col>
        <v-col cols="5" class="d-flex align-center justify-end">
          <span class="white--text font-weight-bold">
            Project's Transaction Type
          </span>
        </v-col>
      </v-row>
    </div>
    <div class="fixed-top-bar2 d-flex align-center">
      <v-row>
        <v-col cols="12">
          <router-link to="/report/2" v-slot="{ href, navigate }">
            <a :href="href" @click="navigate">
              Report
            </a>
          </router-link>
          <span> / </span>
          <span>{{project_name}}</span>
        </v-col>
      </v-row>
    </div>
    <v-overlay absolute :value="loading">
      <v-icon style="font-size: 80px;">mdi-progress-clock mdi-spin</v-icon>
    </v-overlay>
    <v-card tile style="background:none" flat>
      <v-card-text
        class="pa-0 mx-auto"
      >
        <v-data-table
          :headers="headers"
          class="elevation-1 rounded-0 my-transaction-table fix-table-layout fix-table-header"
          item-key="user_id"
          :search="search"
          :items="items.data"
          mobile-breakpoint="50"
          dense
          :items-per-page="pagination.itemsPerPage"
          hide-default-footer
          :options.sync="pagination"
          :page.sync="pagination.page"
          @page-count="items.last_page"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td width="22%">{{ item.name }}</td>
              <td width="12%"><div class="text-right">
                  <span
                    v-if="item.credit != '0.00'"
                    class="primary--text"
                    >${{ getAmountFormat(item.credit) }}</span
                  >
                </div></td>
              <td width="12%"><div class="text-right">
                  <span
                    v-if="item.debit != '0.00'"
                    class="error--text"
                    >${{ getAmountFormat(item.debit) }}</span
                  >
                </div></td>
              <td width="12%"><div class="text-right">
                  <span
                    :class="{
                      'error--text': item.balance < 0,
                      'primary--text': item.balance > 0,
                    }"
                    >${{ getAmountFormat(item.balance) }}</span
                  >
                </div>
              </td>
              <td width="4%">
                <v-btn
                  icon
                  style="height:unset;"
                  :to="redirectLink(item)"
                >
                  <v-icon>mdi-eye-outline</v-icon>
                </v-btn>
              </td>
              <td width="38%"></td>
            </tr>
          </template>

          <template v-slot:body.append>
            <tr class="grey lighten-1 fix-bottom-bar pr-3">
              <td colspan="2" width="22%" class="text-right">
                Total: 
              </td>
              <td width="12%" >
                <div class="text-right">
                  <span
                    v-if="total_credit != '0.00'"
                    class="white--text green"
                    >${{ getAmountFormat(total_credit) }}</span
                  >
                </div>
              </td>
              <td width="12%" >
                <div class="text-right">
                  <span
                    v-if="total_debit != '0.00'"
                    class="white--text red"
                    >${{ getAmountFormat(total_debit) }}</span
                  >
                </div>
              </td>
              <td width="12%" >
                <div class="text-right">
                  <span
                    :class="{
                      'red': total_balance < 0,
                      'green': total_balance > 0,
                    }"
                    class="white--text"
                    >${{ getAmountFormat(total_balance) }}</span
                  >
                </div>
              </td>
              <td colspan="2" width="42%">
              </td>
            </tr>
          </template>

        </v-data-table>
        <div class="v-data-footer custom-pagination fix-footer-bar">
          <v-row dense="">
            <v-col cols="6" class="d-flex align-center justify-end">
              <span>Total Record: {{items.total}}</span>
              <div class="v-data-footer__select pl-5">Rows per page: 
                <v-select
                  v-model="pagination.itemsPerPage"
                  :items="pagination_settings.perPageList"
                  dense=""
                  hide-details=""
                ></v-select>
              </div>
            </v-col>
            <v-col cols="6" class="d-flex align-center justify-start">
              <v-pagination
              class="d-flex align-center justify-start"
                v-model="pagination.page"
                :length="items.last_page"
                total-visible="10"
              ></v-pagination>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import axios from "../../plugins/axios";
import { parseParams } from "../../plugins/helper";
import { mapState } from "vuex";
export default {
  name: "UsersList",
  data() {
    return {
      loading: false,
      items: {
        data: [],
      },
      filter_menu: false,
      total_balance: 0,
      total_credit: 0,
      total_debit: 0,
      project_name: "",
      filter_view_by: 'transactiontype',
      headers: [
        { value: "name", text: "Name", sortable: false, width: "22%" },
        { value: "credit", text: "Income", sortable: false, align: "right", width: "12%"},
        { value: "debit", text: "Expense", sortable: false, align: "right", width: "12%" },
        { value: "balance", text: "Balance", sortable: false, align: "right", width: "12%" },
        { value: "", text: "", sortable: false, width: "4%" },
        { value: "", text: "", sortable: false, width: "38%" },
      ],
      view_by: [
        { text: "Vendor", value: "vendor" },
        { text: "Transaction Type", value: "transactiontype" },
      ],
      pagination: {
        itemsPerPage: -1,
        sortBy: [],
        page: 1,
        filters: {
          project_id: this.$route.params.project_id
        },
      },
    };
  },
  computed: {
    ...mapState("utils", ["pagination_settings"]),
    pageData() {
      let paginationData = this.pagination;
      return paginationData;
    },
  },
  watch: {
    pagination: {
      handler: function () {
        this.getSummary();
      },
      deep: true,
    },
  },
  methods: {
    changeFilter() {
      this.$router.push({ path: "/report/project/"+this.$route.params.project_id+"/"+this.filter_view_by });
    },
    redirectLink(item) {
      return '/report/project/'+this.$route.params.project_id+'/transactiontype/'+item.content_id+'/vendor'
    },
    getAmountFormat(value) {
      if(value) {
        value = value.toString();
        return value.replace("-", "");
      } else {
        return 0
      }
    },
    getSummary() {
      let _self = this;
      this.loading = true;
      let url = parseParams(this.pageData);
      axios.get("transaction_project_transaction_type?" + url)
        .then((response) => {
          if (_self.items.total != response.data.data.total) {
            _self.pagination.page = 1;
          }
          _self.items = response.data.data;
          _self.total_balance = response.data.total_balance;
          _self.total_credit = response.data.total_credit;
          _self.total_debit = response.data.total_debit;
          _self.project_name = response.data.project_name
          _self.loading = false;
        })
        .catch(function () {
          _self.loading = false;
        });
    },
  },
  mounted() {
    //this.getSummary();
  },
};
</script>
<style>

</style>